module.exports = __webpack_public_path__ + "static/Battery_Mount-c94b4418c8f0cca300728d28b35c9043.png";